import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = {
  key: 0,
  class: "dismiss posSt fr"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "titleHeadBorder fs18 ls1"
}
const _hoisted_5 = { class: "customWeekButtons" }
const _hoisted_6 = ["data-testid", "onClick"]
const _hoisted_7 = {
  key: 0,
  class: "fl mt17",
  style: {}
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["data-testid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_SelectTag = _resolveComponent("SelectTag")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FlashNotice),
    (_ctx.currentDateTag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.direct)
            ? (_openBlock(), _createElementBlock("a", _hoisted_2, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/popUp/dismiss.png`),
                  width: "33",
                  height: "33"
                }, null, 8, _hoisted_3)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "mc",
            style: _normalizeStyle(`${_ctx.direct ? '' : 'height:500px;padding:35px 50px;'}text-align:left;`)
          }, [
            (!_ctx.direct)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_4, "    " + _toDisplayString(_ctx.changeOrNew == "change" ? "変更" : "新規追加"), 1))
              : _createCommentVNode("", true),
            _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['日', '月', '火', '水', '木', '金', '土'], (type, typeindex) => {
                return _createElementVNode("span", {
                  key: `${type}${typeindex}${_ctx.currentDateTag.systemUpdatedAt}`
                }, [
                  _createElementVNode("p", {
                    "data-testid": _ctx.direct ? `room-settings-available-day-${typeindex}` : null,
                    class: _normalizeClass(`fl circleBlueButton ${_ctx.isSP ? `mr10` : `mr10`} pointer wd${typeindex} ${
                                _ctx.currentDateTag && _ctx.currentDateTag.days_of_the_week.includes(typeindex) ? `selected` : ``
                            }`),
                    onClick: ($event: any) => (_ctx.selectCheckbox(typeindex))
                  }, _toDisplayString(type), 11, _hoisted_6)
                ])
              }), 64)),
              _createElementVNode("p", {
                class: _normalizeClass(`fl circleRedButton ${_ctx.isSP ? `mr10` : `mr10`} pointer wdholi ${
                            _ctx.currentDateTag?.use_holiday ? `selected` : ``
                        }`),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectCheckboxHoliday && _ctx.selectCheckboxHoliday(...args)))
              }, " 祝 ", 2),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "clear" }, null, -1)),
              _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_SelectTag, {
                name: "meeting_start_time",
                id: "select_meeting_start_time",
                testid: _ctx.direct ? `room-settings-available-time-start` : null,
                class: "fl fs14 roundForm noBorder",
                style: {"width":"90px","height":"50px"},
                options: _ctx.timeArray,
                defaultOption: _ctx.startTimeStr,
                onSelectValue: _ctx.selectStartTime
              }, null, 8, ["testid", "options", "defaultOption", "onSelectValue"]),
              (_ctx.direct)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, "  〜"))
                : _createCommentVNode("", true),
              _cache[6] || (_cache[6] = _createTextVNode("   ", -1)),
              _createVNode(_component_SelectTag, {
                name: "meeting_end_time",
                id: "select_meeting_start_time",
                testid: _ctx.direct ? `room-settings-available-time-end` : null,
                class: "fl fs14 roundForm noBorder",
                style: {"width":"90px","height":"50px"},
                options: _ctx.timeArray,
                defaultOption: _ctx.endTimeStr,
                onSelectValue: _ctx.selectEndTime
              }, null, 8, ["testid", "options", "defaultOption", "onSelectValue"]),
              _cache[7] || (_cache[7] = _createElementVNode("p", {
                class: "fl mt16",
                style: {}
              }, " までなら可能です。", -1)),
              (_ctx.isSP)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("br", null, null, -1),
                    _createElementVNode("br", null, null, -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createElementVNode("p", {
                "data-testid": _ctx.direct ? `room-settings-available-time-add-button` : null,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addDtag && _ctx.addDtag(...args))),
                class: "pointer centered circle_button skyblueBg fs16 fl",
                style: {"width":"80px","border-radius":"8px","padding":"11px 8px"}
              }, " 追加 ", 8, _hoisted_9),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clear" }, null, -1))
            ])
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ]))
}